/**
 * 0.160 (ADR 0166, Briefing „Flüssige Oberfläche“ F05): Fokus kehrt nach dem Schließen eines Fensters an den Auslöser
 * zurück – auch wenn der Auslöser beim Klick keinen Fokus bekam (Zeilen mit Ziehen, Safari) oder neu gezeichnet wurde.
 * Gemerkt wird das zuletzt per Zeiger berührte oder fokussierte bedienbare Element außerhalb von Fenstern.
 */
const FOCUSABLE = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
let last: { el: HTMLElement; taskId: string | null } | null = null;

function note(target: EventTarget | null) {
  const el = (target as HTMLElement | null)?.closest?.<HTMLElement>(FOCUSABLE);
  if (!el) return;
  last = { el, taskId: el.closest<HTMLElement>('[data-task-id]')?.dataset.taskId ?? null };
}

if (typeof document !== 'undefined') {
  document.addEventListener('pointerdown', (e) => note(e.target), true);
  document.addEventListener('focusin', (e) => note(e.target), true);
}

/** Auslöser beim Öffnen merken */
export function captureTrigger() {
  return last;
}

/** Fokus zurückgeben; `false`, wenn kein sinnvolles Ziel mehr da ist (dann entscheidet Radix) */
export function returnFocus(trigger: ReturnType<typeof captureTrigger>): boolean {
  if (!trigger) return false;
  let el: HTMLElement | null = trigger.el.isConnected ? trigger.el : null;
  if (!el && trigger.taskId) {
    const row = document.querySelector<HTMLElement>(`[data-task-id="${CSS.escape(trigger.taskId)}"]`);
    el = row?.querySelector<HTMLElement>('[data-task-title]') ?? row?.querySelector<HTMLElement>(FOCUSABLE) ?? null;
  }
  if (!el || el.closest('[inert]')) return false;
  el.focus({ preventScroll: true });
  return document.activeElement === el;
}
